<template>
    <div>
        <el-table id="outTable"  ref="table" border :data="tableData" :span-method="arraySpanMethod" >
            <el-table-column label="图片" width="120" align="center">
                <template slot-scope="scope">
                    <el-popover trigger="hover" title="" placement="right">
                        <img :src="scope.row.mainPic" style="width: 200px;height: 200px;object-fit: contain">
                        <img slot="reference" :src="scope.row.mainPic" style="width: 90px;height: 90px;object-fit: contain">
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="proTitle" label="标题/产品ID" width="500">
                <template slot-scope="scope">
                    <el-row style="text-align: left">{{scope.row.proTitle}}</el-row>
                    <el-row>备注:{{scope.row.remarks}}</el-row>
                </template>
            </el-table-column>
            <el-table-column prop="htmlCode"   label="SKU" align="center">
                <template slot-scope="scope">
                    <div v-html="scope.row.htmlCode"></div>
                </template>
            </el-table-column>
            <el-table-column label="价格"  align="center"></el-table-column>
            <el-table-column prop="createTime" label="时间" align="left" width="200">
                <template slot-scope="scope">
                    <el-row>创建时间:</el-row>
                    <el-row>{{scope.row.createTime}}</el-row>
                    <el-row>更新时间:</el-row>
                    <el-row>{{scope.row.updateTime}}</el-row>
                </template>
            </el-table-column>
            <el-table-column  label="操作" align="center">
                <div slot-scope="scope">
                    <div><el-button  type="text" size="mini" @click="edit(scope.row)">编辑</el-button><br/></div>
                    <div><el-button  type="text" size="mini" @click="addRemark(scope.row)">添加备注</el-button><br/></div>
                    <div v-if="scope.row.dzStatus =='01' "><el-button  type="text" size="mini" @click="offShelf(scope.row)" >下架产品</el-button><br/></div>
                    <div v-if="scope.row.dzStatus =='02'|| scope.row.dzStatus=='03'"><el-button  type="text" size="mini" @click="onShelf(scope.row)" >上架产品</el-button><br/></div>
                    <div v-if="scope.row.dzStatus =='04'"><el-button  type="text" size="mini" @click="realDelete(scope.row)" >彻底删除</el-button><br/></div>
                    <div v-if="scope.row.dzStatus !='04'"><el-button  type="text" size="mini" @click="deleteRow(scope.row)">删除</el-button></div>
                </div>
            </el-table-column>
        </el-table>
        <pagination
                :total="total"
                :page.sync="form.pageNum"
                :limit.sync="form.pageSize"
                @pagination="loadData"
        />
    </div>
</template>

<script>
    export default {
        name: "commonTab",
        data(){
            return{
                total:0,
                form:{
                    pageSize:30,
                    pageNum:1
                },
                tableData:[]
            }
        },
        methods:{
            //加载表格数据
            loadData(){

            },
            //合并列
            arraySpanMethod: function({row,column,rowIndex,columnIndex}) {
                if (columnIndex === 3) {
                    return [1, 2];
                }else if(columnIndex === 4){
                    //将合并后的第四、五、六列单元格清除掉，不然后面的单元格会后移
                    return [0, 1];
                }
            },
        }
    }


</script>

<style scoped>

</style>
